import { render, staticRenderFns } from "./FigmaTextLayer.vue?vue&type=template&id=3fc6db3a&scoped=true"
import script from "./FigmaTextLayer.vue?vue&type=script&lang=js"
export * from "./FigmaTextLayer.vue?vue&type=script&lang=js"
import style0 from "./FigmaTextLayer.vue?vue&type=style&index=0&id=3fc6db3a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc6db3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc6db3a')) {
      api.createRecord('3fc6db3a', component.options)
    } else {
      api.reload('3fc6db3a', component.options)
    }
    module.hot.accept("./FigmaTextLayer.vue?vue&type=template&id=3fc6db3a&scoped=true", function () {
      api.rerender('3fc6db3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/figma-layers/layers/FigmaTextLayer.vue"
export default component.exports